import { inject } from "fw";
import { Manager } from "./manager";
import { createFrom } from "fw-model";
import { PlatformStatus, PlatformBackupStatus, PlatformMetricsCharts, PlatformElasticsearchInfo } from "models/platform";

@inject
export class PlatformRepository {
    constructor(private s: Manager) {}

    public async backups() {
        const res = await this.s.get("platform/backups");
        return createFrom(PlatformBackupStatus, res.body);
    }

    public async elasticsearch(): Promise<PlatformElasticsearchInfo> {
        const res = await this.s.get("platform/elasticsearch");
        return createFrom(PlatformElasticsearchInfo, res.body);
    }

    public async status() {
        const res = await this.s.get("platform/status");
        return createFrom(PlatformStatus, res.body);
    }

    public async charts(chartWidth: number = null, chartHeight: number = null, timezoneOffset: number = null) {
        const res = await this.s.get("platform/metrics/charts", { chartWidth, chartHeight, timezoneOffset });
        return createFrom(PlatformMetricsCharts, res.body);
    }
}
